import {
  Card,
  CardCaption,
  CardTitle,
  EducationScreen,
  Gold,
  PharmacyGlyph,
  RevealBlock,
  ScreenBody,
  ScreenIntro,
  ScreenSubhead,
} from './EducationShell';
import {SleepBlocksViz} from './Step8Viz';
import styles from './Glp1EducationIntroCompounded.module.css';

/** Step 8 — compounded variant. Headline frames the medication as "custom
 *  dosed for sleep apnea"; credibility row is a state-licensed pharmacy
 *  disclosure instead of FDA. Card 2 drops the bar viz per Figma 336:3448. */
export const Glp1EducationIntroCompounded = () => (
  <EducationScreen
    ctaLabel="Show me"
    variant="compounded_v1"
    analyticsShown="GLP-1 Funnel Education Intro Viewed"
    analyticsSubmitted="GLP-1 Funnel Education Intro Show Me Tapped"
  >
    <ScreenIntro
      headline={
        <>
          <Gold>GLP-1 medication</Gold>, custom dosed for sleep apnea.
        </>
      }
      subhead="For decades, CPAP was the only real option. Now there's another path."
    />

    <RevealBlock delayMs={300}>
      <Card>
        <CardTitle>
          Fewer <Gold>breathing interruptions</Gold>
        </CardTitle>
        <SleepBlocksViz delayMs={200} variant="compounded" />
        <CardCaption>
          As you lose weight, pressure on your airway eases. Collapses happen less often, and sleep blocks get longer.
          <br />
          (Peppard et al., Wisconsin Sleep Cohort · JAMA, 2000)
        </CardCaption>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={500}>
      <div className={styles.pharmacyRow}>
        <span className={styles.pharmacyGlyph}>
          <PharmacyGlyph />
        </span>
        <p className={styles.pharmacyTitle}>Fulfilled by a licensed pharmacy with board-certified pharmacists.</p>
      </div>
    </RevealBlock>

    <RevealBlock delayMs={300}>
      <Card>
        <CardTitle>
          Time in bed becomes <Gold>restful sleep</Gold>
        </CardTitle>
        <CardCaption>
          As breathing settles, more of the time you spend in bed is actually restful sleep. Based on weight-loss → AHI
          relationship from Peppard et al. (2000). Individual results vary.
        </CardCaption>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={300}>
      <ScreenSubhead>What it feels like.</ScreenSubhead>
      <ScreenBody>Many people notice exhaustion start to lift as their sleep improves.</ScreenBody>
    </RevealBlock>
  </EducationScreen>
);

export default Glp1EducationIntroCompounded;
